import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Guide from "@/pages/Guide";
import FoundingSeller from "@/pages/FoundingSeller";
import FoundingAdmin from "@/pages/FoundingAdmin";
import Roadmap from "@/pages/Roadmap";
import PlacementInsights from "@/pages/PlacementInsights";
import Pricing from "@/pages/Pricing";
import Profitability from "@/pages/Profitability";
import FantasticFinds from "@/pages/FantasticFinds";
import CommunityFinds from "@/pages/CommunityFinds";
import PlansPage from "@/pages/PlansPage";
import Portfolio from "@/pages/Portfolio";
import Dashboard from "@/pages/Dashboard";
import ReviewWorkspace from "@/pages/ReviewWorkspace";
import ProSellerTips from "@/pages/ProSellerTips";
import BigPicture from "@/pages/BigPicture";
import FounderStory from "@/pages/FounderStory";
import CommunityPage from "@/pages/CommunityPage";
import TermsPage from "@/pages/TermsPage";
import FaqPage from "@/pages/FaqPage";
import NotFound from "@/pages/NotFound";
import FeedbackWidget from "@/components/FeedbackWidget";
import FoundingWelcome from "@/components/FoundingWelcome";

function AppRoutes() {
  const location = useLocation();
  // CRITICAL: process a returning Google OAuth session_id BEFORE any protected route runs.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/big-picture" element={<BigPicture />} />
      <Route path="/founders-story" element={<FounderStory />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/guide" element={<Guide />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/tips" element={<ProSellerTips />} />
      <Route path="/founding" element={<FoundingSeller />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/review" element={<ProtectedRoute><ReviewWorkspace /></ProtectedRoute>} />
      <Route path="/review/:listingId" element={<ProtectedRoute><ReviewWorkspace /></ProtectedRoute>} />
      <Route path="/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
      <Route path="/admin/founding" element={<ProtectedRoute><FoundingAdmin /></ProtectedRoute>} />
      <Route path="/roadmap" element={<ProtectedRoute><Roadmap /></ProtectedRoute>} />
      <Route path="/community" element={<ProtectedRoute><CommunityPage /></ProtectedRoute>} />
      <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
      <Route path="/profitability" element={<ProtectedRoute><Profitability /></ProtectedRoute>} />
      <Route path="/finds" element={<ProtectedRoute><FantasticFinds /></ProtectedRoute>} />
      <Route path="/finds/community" element={<CommunityFinds />} />
      <Route path="/plans" element={<PlansPage />} />
      <Route path="/admin/insights" element={<ProtectedRoute><PlacementInsights /></ProtectedRoute>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <FeedbackWidget />
          <FoundingWelcome />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
